import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
body {
  background: ${(props: any) => props.theme.palette.background.default};
  font-family: Ubuntu; 
}

html {
  @font-face {
    font-family: 'Airwave-Regular';
    font-style: normal;
    font-weight: normal;
    src: url(${require("../../assets/fonts/Airwave-Regular.ttf")});
  }
  @font-face {
    font-family: 'Ubuntu-Light';
    font-style: normal;
    font-weight: 300;
    src: url(${require("../../assets/fonts/Ubuntu-Light.woff2")});
  }
  @font-face {
    font-family: 'Ubuntu';
    font-style: normal;
    font-weight: 400;
    src: url(${require("../../assets/fonts/Ubuntu-Regular.woff2")});
  }
  @font-face {
    font-family: 'Ubuntu-Medium';
    font-style: normal;
    font-weight: 500;
    src:  url(${require("../../assets/fonts/Ubuntu-Medium.woff2")});
  }
  @font-face {
    font-family: 'Ubuntu-Bold';
    font-style: normal;
    font-weight: 700;
    src:  url(${require("../../assets/fonts/Ubuntu-Bold.woff2")});
  }
  @font-face {
    font-family: 'text-security-disc';
    font-style: normal;
    font-weight: 400;
    src:  url(${require("../../assets/fonts/text-security-disc.ttf")});
  }
  box-sizing: border-box;

  scrollbar-color: ${(props) => props.theme.scrollbarThumb} ${(props) =>
  props.theme.scrollbarTrack};
}

*, *::before, *::after {
  box-sizing: inherit;
  margin: 0;  
}

.drawer > div {
  background-color: transparent;
}

.right-drawer {
    height: 100%;
    &:focus {
      outline: none;
    }
  }

.appName {
  font-size: 36px;
  font-family: Airwave-Regular;
  color: #424e60;
  line-height: 1;
  font-weight: normal;  
}

.headerLogo {
  font-size: 24px;
  font-family: Airwave-Regular;
  line-height: 1;
  font-weight: normal;  
}

h4 {
  font-family: Ubuntu-Light;
  font-size: 36px;
  color: ${(props) => props.theme.medium};
  line-height: 1.11;
  letter-spacing: 0.3px;
  font-weight: 300;
  margin: 0;
}

h5 {
  font-family: Ubuntu-Light;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.17;
  letter-spacing: normal;
  color: ${(props) => props.theme.high};
}

h6 {
  font-size: 20px;
  color: ${(props) => props.theme.medium};
  line-height: 1.2;
  letter-spacing: 0.2px;
  font-weight: normal;
  margin: 0;
}

.subtitle1 {
  font-family: Ubuntu-Light;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.2px;
  font-weight: 300;
}

.subtitle2 {
  font-family: Ubuntu-Light;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  font-weight: 300;
}

.overline {
  font-family: Ubuntu-Bold;
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 1.5px;
  font-weight: bold;
}

.body1 {
  font-size: 16px;
  line-height: 1.75;
  letter-spacing: 0.3px;
  font-weight: normal;
}

.body2 {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.3px;
  font-weight: normal;
}

.body3 {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.3px;
  font-weight: bold;
}

.caption {
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.4px;
  font-weight: normal;
}

a {
  text-decoration: none;
  color: ${(props) => props.theme.palette.primary.contrastText};
}

[role="menuitem"] a{
  color: ${(props) => props.theme.high}
}

.link {
  cursor: pointer;
  color: #ff9d5b;
}

.light {
  color: ${(props) => props.theme.light};
}

.medium {
  color: ${(props) => props.theme.medium};
}

.disabled {
  color: ${(props) => props.theme.disabled};
}

.high{
  color: ${(props) => props.theme.high};
}

.menu-item {
  display: grid;
  align-items: center;
  min-height: 48px;
  padding: 0 16px;
  outline: none;
  cursor: pointer;
  color: ${(props) => props.theme.high};
  &:hover {
    background: ${(p) => p.theme.opacityMask8};
     transition: background 0.3s ease-out;
  }
}

.menu-item-divider {
  margin: 8px 0;
  outline: none;
  border-color: ${(props) => props.theme.disabled};
}
`;
